export default __webpack_public_path__ + "static/media/dining4.9a5ecf75.JPG";